import React from "react";
import Lottie from "lottie-react";
import upload from "./upload.json";
import write from "./write.json";
import blog from "./blog.json";
import { Container, Row, Col } from "react-bootstrap";
import { Typography, useMediaQuery } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { CardActionArea } from "@mui/material";
import AOS from "aos";
import "aos/dist/aos.css";
import styles from "./Objective.module.css";

const Objective = () => {
  const style = {
    height: 180,
  };

  React.useEffect(() => {
    AOS.init();
  }, []);

  const matches = useMediaQuery("(max-width:768px)");

  return (
    <Container>
      <Typography
        className="py-3"
        fontWeight={600}
        variant={matches ? "h5" : "h4"}
        gutterBottom
      >
        The objectives of <span className="text-primary">PRTP</span> are to
        train up a trainee
      </Typography>
      <Row
        xs={1}
        sm={2}
        md={2}
        xl={3}
        className="justify-content-center g-4 py-5"
        id="objective"
      >
        {Objectives.map((obj, idx) => (
          <Col key={idx} data-aos="zoom-in">
            <Card elevation={3} className={`${styles.zoom} rounded-4`}>
              <CardActionArea className="d-flex flex-column justify-content-center py-3">
                <Lottie style={style} animationData={obj.anim} loop={true} />
                <CardContent align="center">
                  <Typography
                    className="fw-bold"
                    gutterBottom
                    variant="subtitle1"
                    component="div"
                  >
                    {obj.title}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Objective;

const Objectives = [
  {
    anim: write,
    title: "Conduct a research work",
  },
  {
    anim: blog,
    title: "Write down a research paper",
  },
  {
    anim: upload,
    title: "Publish or submit a research paper",
  },
];
